import { render, staticRenderFns } from "./EditPartners.vue?vue&type=template&id=225578a6&scoped=true&"
import script from "./EditPartners.vue?vue&type=script&lang=js&"
export * from "./EditPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225578a6",
  null
  
)

export default component.exports